"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CREATE_SCOPE_MODAL_KEY = exports.SCOPES_STATE_KEYS = exports.SCOPES_STATE_KEY_NAME = void 0;
var SCOPES_STATE_KEY_NAME = 'scopes';
exports.SCOPES_STATE_KEY_NAME = SCOPES_STATE_KEY_NAME;
var SCOPES_STATE_KEYS = {
  CREATE_SCOPE: 'createScope',
  UPDATE_SCOPE: 'updateScope',
  LIST: 'list'
};
exports.SCOPES_STATE_KEYS = SCOPES_STATE_KEYS;
var CREATE_SCOPE_MODAL_KEY = 'create-scope-modal';
exports.CREATE_SCOPE_MODAL_KEY = CREATE_SCOPE_MODAL_KEY;
//# sourceMappingURL=constants.js.map